var map = {
	"./不良司.png": "f2a7",
	"./九玄.png": "b5f6",
	"./古灵.png": "4f9f",
	"./唐门.png": "e929",
	"./妖魔岭.png": "344d",
	"./弈剑.png": "c949",
	"./普陀.png": "d10c",
	"./青丘.png": "5e85",
	"./高老庄.png": "6654",
	"./龙宫.png": "ace2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edec";